import { useEffect, useState } from 'react';
import { getReservationServices } from '../../../services/reservation';
import orderBy from 'lodash/orderBy';

const useReservationServices = () => {
  const [data, setData] = useState([]);
  const [params, setParams] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!params) {
      return null;
    }

    setData();
    setIsLoading(true);
    getReservationServices({ id: params.reservationId })
      .then(response => {
        const orderByBlock = orderBy(response, 'block');
        setData(orderByBlock);
      })
      .catch(error => {
        setError(error)
      })
      .finally(() => {
        setIsLoading(false);
      })
  }, [params])

  return { data, error, setParams, isLoading };
};

export default useReservationServices;